import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { init } from "../../../redux/actions/photothequeActions";
import Filter from "./FilterContainer";
import Gallery from "./GalleryContainer";
import RangePicker from "./DateFilterContainer";
import BestofFilter from "../../../components/phototheque/BestofFilter";
import BeforeAfterFilter from "../../../components/phototheque/BeforeAfterFilter";
import Club100Filter from "../../../components/phototheque/Club100Filter";
import { GSK_PHARMA_ID, roles } from "../../../configs/constants";
import { selectUserRoleId } from "../../../redux/selectors/user";
import AuthRender from "../../AuthRender";

/**
 * Filters access control
 * display only
 * @type {{brands: ((function(*, *): (boolean))|*), beforeAfter: ((function(*, *): (boolean))|*), users: ((function(*, *): (boolean))|*), products: ((function(*, *): (boolean))|*)}}
 */
const filtersAC = {
  users: (clientId, roleId) => {
    if (clientId === 3 && roleId === roles.CLIENT) {
      return false;
    }

    if (clientId === 17 && roleId === roles.TERRAIN) {
      return false;
    }

    return true;
  },
  beforeAfter: (clientId, roleId) => {
    if (clientId === 3 && roleId === roles.CLIENT) {
      return false;
    }
    return true;
  },
  brands: (clientId, roleId) => {
    if (clientId === 3 && roleId === roles.CLIENT) {
      return false;
    }
    return true;
  },
  products: (clientId, roleId) => {
    if (clientId === 3 && roleId === roles.CLIENT) {
      return false;
    }
    return true;
  }
};

class Phototheque extends PureComponent {
  constructor(props) {
    super(props);
    this.props.init({});
  }

  render() {
    const { isClient, currentClientId, roleId } = this.props;
    return (
      <Fragment>
        <div class="p-content-page-center p-content-page-center-full">
          <div class="p-content-page-center-header">
            <h2 class="p-content-page-center-header-title">Liste des photos</h2>
          </div>
          <div class="p-content-page-center-filters">
            <div className="p-mrg-right p-mrg-bot" style={{ width: 230 }}>
              <RangePicker filterTargetKey={"period"} />
            </div>
            <AuthRender customAC={() => filtersAC.users(currentClientId, roleId)}>
              <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
                <Filter
                  filterTargetKey={"user_email"}
                  placeholder={"Utilisateurs"}
                  defaultValue={this.props.currentEmails.length > 0 ? this.props.currentEmails : undefined}
                />
              </div>
            </AuthRender>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"sector.sector_label"}
                placeholder={"Secteurs"}
                defaultValue={this.props.currentSectors.length > 0 ? this.props.currentSectors : undefined}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"retailer.retailer_label"}
                placeholder={"Enseignes"}
                defaultValue={this.props.currentRetailers.length > 0 ? this.props.currentRetailers : undefined}
              />
            </div>

            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"salepoint.label"}
                placeholder={"PDC"}
                depKey={"retailers"}
                defaultValue={this.props.currentPdcs.length > 0 ? this.props.currentPdcs : undefined}
              />
            </div>

            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"location.label"}
                placeholder={"emplacement"}
                defaultValue={this.props.currentLocations.length > 0 ? this.props.currentLocations : undefined}
              />
            </div>

            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"statement.label"}
                placeholder={"Actions"}
                defaultValue={this.props.currentStatements.length > 0 ? this.props.currentStatements : undefined}
              />
            </div>

            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"survey_id"}
                placeholder={"Questionnaire"}
                defaultValue={this.props.currentSurveys.length > 0 ? this.props.currentSurveys : undefined}
              />
            </div>
            {(!isClient || currentClientId === GSK_PHARMA_ID) && (
              <div className="p-mrg-right" style={{ width: 150 }}>
                <BestofFilter filterTargetKey={"best"} placeholder={"Best of"} />
              </div>
            )}
            <AuthRender customAC={() => filtersAC.beforeAfter(currentClientId, roleId)}>
              <div className="p-mrg-right" style={{ width: 150 }}>
                <BeforeAfterFilter filterTargetKey={"beforeafter"} placeholder={"Avant/Après"} />
              </div>
            </AuthRender>
            <AuthRender customAC={() => filtersAC.brands(currentClientId, roleId)}>
              <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
                <Filter
                  filterTargetKey={"brands.label"}
                  placeholder={"Marques"}
                  defaultValue={this.props.currentBrands.length > 0 ? this.props.currentBrands : undefined}
                />
              </div>
            </AuthRender>
            <AuthRender customAC={() => filtersAC.products(currentClientId, roleId)}>
              <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
                <Filter
                  filterTargetKey={"products.label"}
                  placeholder={"Produits"}
                  defaultValue={this.props.currentProducts.length > 0 ? this.props.currentProducts : undefined}
                />
              </div>
            </AuthRender>

            {GSK_PHARMA_ID === currentClientId && (
              <div className="p-mrg-right" style={{ width: 150 }}>
                <Club100Filter filterTargetKey={"salepoint.club_100"} placeholder={"Club 100"} />
              </div>
            )}

            {GSK_PHARMA_ID === currentClientId && (
              <div className="p-mrg-bot p-mrg-bot" style={{ width: 150 }}>
                <Filter
                  filterTargetKey={"salepoint.group_label"}
                  placeholder={"Groupement"}
                  defaultValue={this.props.currentGroupLabel.length > 0 ? this.props.currentGroupLabel : undefined}
                />
              </div>
            )}
          </div>

          <Gallery />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const currentClientState = state.currentClient || {};
  const roleId = selectUserRoleId(state);
  const isClient = roleId === roles.CLIENT;
  return {
    isClient,
    roleId,
    currentClientId: currentClientState.id,
    currentSectors: state.phototheque.currentFilters["sector.sector_label"]
      ? state.phototheque.currentFilters["sector.sector_label"]
      : [],
    currentRetailers: state.phototheque.currentFilters["retailer.retailer_label"]
      ? state.phototheque.currentFilters["retailer.retailer_label"]
      : [],
    currentPdcs: state.phototheque.currentFilters["salepoint.label"]
      ? state.phototheque.currentFilters["salepoint.label"]
      : [],
    currentEmails: state.phototheque.currentFilters["user_email"] ? state.phototheque.currentFilters["user_email"] : [],
    currentSurveys: state.phototheque.currentFilters["survey_id"] ? state.phototheque.currentFilters["survey_id"] : [],
    currentStatements: state.phototheque.currentFilters["statement.label"]
      ? state.phototheque.currentFilters["statement.label"]
      : [],
    currentLocations: state.phototheque.currentFilters["location.label"]
      ? state.phototheque.currentFilters["location.label"]
      : [],
    currentBrands: state.phototheque.currentFilters["brands.label"]
      ? state.phototheque.currentFilters["brands.label"]
      : [],
    currentProducts: state.phototheque.currentFilters["products.label"]
      ? state.phototheque.currentFilters["products.label"]
      : [],

    currentGroupLabel: state.phototheque.currentFilters["salepoint.group_label"]
      ? state.phototheque.currentFilters["salepoint.group_label"]
      : []
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: () => {
      dispatch(init());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Phototheque);



// WEBPACK FOOTER //
// src/containers/activite/phototeque/index.js